// extracted by mini-css-extract-plugin
export default {"container":"error-bage_container__V3669"};